import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/Home.vue')
  },
  {
    path: '/welcome',
    name: 'welcome',
    component: () => import('../views/Welcome.vue')
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('../views/Dashboard.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../components/Login.vue')
  },
  /*{
    path: '/signup',
    name: 'signup',
    component: () => import('../components/Signup.vue')
  },*/
  {
    path: '/users/add',
    name: 'add_user',
    component: () => import('../components/users/UserCreate.vue')
  },
  {
    path: '/users/list',
    name: 'list_users',
    component: () => import('../components/users/UserList.vue')
  },
  {
    path: '/users/detail',
    name: 'user_detail',
    component: () => import('../components/users/UserDetail.vue')
  },
  {
    path: '/users/edit',
    name: 'edit_user',
    component: () => import('../components/users/UserEdit.vue')
  },
  {
    path: '/cards/add',
    name: 'add_card',
    component: () => import('../components/cards/CardCreate.vue')
  },
  {
    path: '/cards/list',
    name: 'list_cards',
    component: () => import('../components/cards/CardList.vue')
  },
  {
    path: '/cards/edit',
    name: 'edit_card',
    component: () => import('../components/cards/CardEdit.vue')
  },
  {
    path: '/dogs/add',
    name: 'add_dog',
    component: () => import('../components/dogs/DogCreate.vue')
  },
  {
    path: '/dogs/edit',
    name: 'edit_dog',
    component: () => import('../components/dogs/DogEdit.vue')
  },
  {
    path: '/subs/add',
    name: 'add_subs',
    component: () => import('../components/subs/SubsCreate.vue')
  },
  {
    path: '/events/list',
    name: 'list_events',
    component: () => import('../components/events/EventList.vue')
  },
  {
    path: '/subs/list',
    name: 'list_subs',
    component: () => import('../components/subs/SubsList.vue')
  },
  {
    path: '/prices/list',
    name: 'list_prices',
    component: () => import('../components/prices/PriceList.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router